<template>
  <modal class="modal cloudapp-modal narrow" id="signup-modal" :hide-footer="true" :hide-header="true">
    <div class="d-flex">
      <div id="left-wrapper">
        <div id="header">
          <img src="@img/logo@2x.png" class="logo"/>
          <span>Sign up</span>
        </div>
        <div id="body">
          <ul class="errors text-danger"></ul>
          <a href="#" class="cloudapp-btn white google-signup google-login-button" @click="authorizeGoogleOauth">
            <img width="19px" src="@img/google_logo.svg" class="mr-2">
            <span>Sign up with Google</span>
          </a>

          <a :href="appleIdUrl" class="btn apple-login-button btn-block btn-light">
            <img src="@img/apple_logo.svg" class="mr-2">
            <span>Sign up with Apple </span>
          </a>



          <small class="form-text text-muted text-center">or</small>

          <form id="modal-signup-form" data-type="json" :action="formAction" accept-charset="UTF-8" data-remote="true" method="post">
            <div class="form-group">
              <label for="email">Work Email</label>
              <input type="email" name="email" id="email" required="required" class="form-control" v-model="email" @keydown.stop>
              <small class="form-text text-muted">We'll never share your email with anyone else.</small>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" name="password" id="password" required="required" autocomplete="off" class="form-control" @keydown.stop>
            </div>
            <div class="text-center">
              <input type="submit" name="commit" value="Create my account" data-disable-with="Create my account" class="cloudapp-btn blue identifyUser create-account">
            </div>
            <div class="modal-footer text-center">
              <a href="/sso/new?utm_campaign=signup_modal&utm_source=viewer">Sign up with SSO</a>
              <p class="supported-oses">For Mac, Windows, and iOS</p>
              <p></p>
              <p class="have-an-account">
                Have a CloudApp account?
                <a href="#" @click="openLoginModal" class="cloudapp-link primary" data-testid="login-link">
                  <span> Log in </span>
                  <i class="fas fa-arrow-right"></i>
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
      <div id="cloudapp-description-wrapper">
        <div class="cloudapp-description-text">Create videos, GIFs, annotated screenshots and share instantly</div>
        <div class="cloudapp-description-image-wrapper">
          <img src="@img/hero-asset.png" class="cloudapp-description-image"/>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@cmp/modal.vue";
import { modalsUser } from "@/src/observable";
import authorizeGoogleOauth from '@/src/google_oauth';

export default {
  components: { Modal },
  props: {
    returnTo: String
  },
  methods: {
    openLoginModal: function(){
      this.$bvModal.show('login-modal');
      this.$bvModal.hide('signup-modal');
    },
    authorizeGoogleOauth: authorizeGoogleOauth
  },
  computed: {
    email: {
      set: function(val){ modalsUser.email = val },
      get: function(){ return modalsUser.email }
    },
    formAction: function(){
      return `/api/v4/account?utm_source=viewer&utm_medium=nav_button_image&utm_content=drop:${this.$route.params.slug}`
    },
    appleIdUrl: () => `/auth/apple?web=true&return_to=${window.location.href}`
  }
}
</script>

<style lang="scss">
  @import '../../packs/application.scss';

  #signup-modal___BV_modal_outer_ {
    .modal-dialog { max-width: 760px;}
    .modal-content { overflow: hidden; }
    .modal-body { padding: 0; }
    .modal-footer {
      display: flex;
      flex-direction: column;
    }

    #header {
      background: white;
      font-size: 24px;
      font-weight: 600;
      display: flex;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid #dee2e6;

      img {
        height: 27px;
        margin-right: 9px;
      }
    }


    #left-wrapper {
      background: $white-three;
      width: 380px;

      #body {
        padding: 20px
      }

      form {
        label {
          font-size: 12px;
          font-weight: 600;
        }
      }

      .create-account {
        margin: 14px 0;
      }
    }

    #cloudapp-description-wrapper {
      display: flex;
      width: 380px;
      max-width: 380px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #6de1ff;
      padding: 20px;

      .cloudapp-description-text {
        color: #373737;
        font-size: 22px;
        font-weight: 700;
        text-align: center;
        margin-top: 40px;
        margin-bottom: 60px;
      }
    }
  }
</style>